import { Component } from '@angular/core';
import { ErrorModalConfig } from './error-modal-config';
import { SkyModalInstance } from '../modal/modal-instance';


export class SkyErrorModalFormComponent {
  constructor(
    public context: ErrorModalConfig,
    public instance: SkyModalInstance) {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-error-modal-form',
  template: `<sky-modal>
  <sky-modal-content>
    <div class="sky-error-modal-container">
      <span class="sky-error-modal-title">{{ context.errorTitle }}</span>
      <span class="sky-error-modal-description">{{ context.errorDescription }}</span>
      <div class="sky-error-modal-close">
        <button
          type="button"
          class="sky-btn sky-btn-primary"
          (click)="instance.close()"
        >
          {{ context.errorCloseText }}
        </button>
      </div>
    </div>
  </sky-modal-content>
</sky-modal>
`,
  styles: [`.sky-error-modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sky-error-modal-title {
  font-weight: bold;
}

.sky-error-modal-description {
  max-width: 100%;
}

.sky-error-modal-close {
  margin-top: 10px;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ErrorModalConfig, },
{type: SkyModalInstance, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
